const FIRST_LCP_FALLBACK_MS = 10_000;

export function afterFirstLcp(signal?: AbortSignal): Promise<void> {
    if (typeof window === "undefined") {
        return Promise.resolve();
    }
    if (signal?.aborted) {
        return Promise.resolve();
    }
    if (typeof PerformanceObserver === "undefined") {
        return waitUntilIdle(signal);
    }

    return new Promise((resolve) => {
        let settled = false;
        let observer: PerformanceObserver | undefined;
        let fallbackId = 0;

        const done = () => {
            if (settled) {
                return;
            }
            settled = true;
            observer?.disconnect();
            window.clearTimeout(fallbackId);
            signal?.removeEventListener("abort", done);
            resolve();
        };

        signal?.addEventListener("abort", done, { once: true });

        try {
            observer = new PerformanceObserver((list) => {
                if (list.getEntries().length > 0) {
                    done();
                }
            });
            observer.observe({
                type: "largest-contentful-paint",
                buffered: true,
            });
        } catch {
            observer?.disconnect();
            void waitUntilIdle(signal).then(done);
            return;
        }

        fallbackId = window.setTimeout(done, FIRST_LCP_FALLBACK_MS);
    });
}

function waitUntilIdle(signal?: AbortSignal): Promise<void> {
    if (typeof window === "undefined" || !("requestIdleCallback" in window)) {
        return Promise.resolve();
    }
    if (signal?.aborted) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        const idleId = window.requestIdleCallback(() => {
            signal?.removeEventListener("abort", onAbort);
            resolve();
        });
        const onAbort = () => {
            window.cancelIdleCallback(idleId);
            resolve();
        };
        signal?.addEventListener("abort", onAbort, { once: true });
    });
}
